import { toWibClock } from '@/lib/dates'
import { sessions } from '@/constants/clinic'

export type ClinicStatus = {
    open: boolean
    label: string
}

const formatMinutes = (minutes: number): string => {
    const hours = Math.floor(minutes / 60)
    const rest = minutes % 60

    return `${String(hours).padStart(2, '0')}.${String(rest).padStart(2, '0')}`
}

/** Live registration status of the outpatient clinics, in WIB. Call it only in the browser after mount. */
export const getClinicStatus = (now: Date): ClinicStatus => {
    const wib = toWibClock(now)
    const weekday = wib.getUTCDay()
    const minutes = wib.getUTCHours() * 60 + wib.getUTCMinutes()
    const { pagi, sore } = sessions

    if (weekday === 0) return { open: false, label: 'Poli tutup hari Minggu, UGD tetap buka' }

    if (minutes >= pagi.opensAt && minutes < pagi.closesAt) {
        return { open: true, label: `Poli buka, pendaftaran pagi sampai ${formatMinutes(pagi.closesAt)}` }
    }

    if (minutes >= sore.opensAt && minutes < sore.closesAt) {
        return { open: true, label: `Poli buka, pendaftaran sore sampai ${formatMinutes(sore.closesAt)}` }
    }

    if (minutes < pagi.opensAt) return { open: false, label: `Pendaftaran pagi dibuka pukul ${formatMinutes(pagi.opensAt)}` }

    if (minutes < sore.opensAt) return { open: false, label: `Jeda siang, pendaftaran sore pukul ${formatMinutes(sore.opensAt)}` }

    const nextDay = weekday === 6 ? 'Senin' : 'besok'

    return { open: false, label: `Poli tutup, buka lagi ${nextDay} pukul ${formatMinutes(pagi.opensAt)}` }
}
